import {
    Box,
    Button,
    Container,
    DialogContentText,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@mui/material";
import Config from "Config";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import {
    getFormTitleParam,
    getIsReleasedForm,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
} from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import CustomDatePicker from "../../component/CustomDatePicker/CustomDatePicker";
import CustomSelect from "../../inputComponent/CustomSelect/CustomSelect";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getFormTitleParamList } from "../../redux/selector";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";
import HistoryTableRow from "./HistoryTableRow";

const useStyles = makeStyles({
    tableRow: {
        textDecoration: "none!important",
    },
});

function HistoryEnquiry() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();

    const [searchResult, setSearchResult] = useState({});
    const [total, setTotal] = useState(0);
    const [formId, setFormId] = useState(null);
    const [referenceNum, setReferenceNum] = useState(null);
    const [status, setStatus] = useState(null);
    const [submissionDateFrom, setSubmissionDateFrom] = useState(null);
    const [submissionDateTo, setSubmissionDateTo] = useState(null);
    const [signatureType, setSignatureType] = useState(null);
    const [roleType, setRoleType] = useState(null);
    const [formStatus, setFormStatus] = useState(null);
    const [selectedFormStatus, setSelectedFormStatus] = useState({});
    const formTitleParam = useSelector(getFormTitleParamList());
    const [formSelectionList, setFormSelectionList] = useState([]);
    const [formSelectionFlag, setFormSelectionFlag] = useState(false);
    const [reportOpen, setReportOpen] = useState(false);
    const [submissionTime, setSubmissionTime] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [res, setRes] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchData(newPage + 1);
    };
    console.log("watch:" + formId, referenceNum, status);
    let data = {};
    const { control, getValues, setValue, register, watch, reset } = useForm({
        defaultValues: 0,
    });
    //获取Form Status data
    function fetchFormStatus() {
        const lang = i18n.language;
        const option = {
            url: `${Config.CONTENT_PATH}/form/getAllStatus/${lang}`,
        };
        dispatch(send("GET_FORM_STATUS", option))
            .then((response) => response.json())
            .then(
                (result) => {
                    // console.log(JSON.stringify(result));
                    setFormStatus(result);
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    }

    //获取table表单数据
    function fetchData(startPage) {
        data[`formRefNum`] = referenceNum;
        data[`formId`] = formId;
        data[`status`] = status;
        data[`startPage`] = startPage;
        data[`submissionDateFrom`] = submissionDateFrom;
        data[`submissionDateTo`] = submissionDateTo;
        data[`signatureType`] = signatureType == "0" ? null : signatureType;
        data[`roleType`] = roleType == "0" ? null : roleType;
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/history`,
            method: "POST",
            body: JSON.stringify(data),
        };
        dispatch(send("SEND_FORM_HISTORY_ENQUIRY", option))
            .then((response) => response.json())
            .then(
                (searchResult) => {
                    setSearchResult(searchResult?.result);
                    setTotal(searchResult?.total);
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    }

    function fetchFormSelectionList() {
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/getFormSelectionList`,
            method: "POST",
        };
        dispatch(send("GET_FORM_SELECTION_LIST", option))
            .then((response) => response.json())
            .then(
                (data) => {
                    setFormSelectionList(data);
                    setFormSelectionFlag(true);
                },
                (error) => {
                    setFormSelectionFlag(false);
                    console.log("error:" + error.message);
                }
            );
    }

    // 处理筛选数据
    const handleFormData = () => {
        let arr = Object.entries(t("form", { returnObjects: true, lng: "en" }))
            .map((r) => {
                return {
                    formId: r[0],
                    name: t(
                        `form.${r[0]}`,
                        getFormTitleParam(r[0], formTitleParam, i18n.language)
                    ),
                };
            })
            //filter the released form
            .filter((r) => {
                return getIsReleasedForm(r.formId);
            });
        return arr;
    };

    useEffect(() => {
        fetchFormSelectionList();
    }, [t]);

    useEffect(() => {
        let obj = handleFormData();
        if (formSelectionList?.[0] && formSelectionList?.[0] === "AllForm") {
            setRes(obj);
        } else {
            let data = obj.filter((item) => {
                return formSelectionList?.includes(item.formId);
            });
            setRes(data);
        }
        // console.log("ressss", res);
    }, [t, formTitleParam, formSelectionFlag]);

    // 处理PDF下载
    // let zipData = {};
    // function getZip() {
    //     let obj = {};
    //     if (!isObjectEmpty(searchResult)) {
    //         searchResult.forEach(function (item) {
    //             if (!obj[item.formId]) obj[item.formId] = [];
    //             obj[item.formId].push(Number(item.refNum));
    //         });
    //         Object.keys(obj).map(function (k) {
    //             return (zipData[k] = obj[k]);
    //         });
    //     }

    //     const option = {
    //         url: `${Config.CONTENT_PATH}/workflow/zip`,
    //         method: "POST",
    //         body: JSON.stringify(zipData),
    //         header: {
    //             Accept: "application/zip",
    //         },
    //     };
    //     dispatch(send("DOWNLOAD_ZIP", option))
    //         .then((res) => res.blob())
    //         .then((result) => {
    //             let aTag = document.createElement("a");
    //             aTag.href = URL.createObjectURL(result);
    //             aTag.download = `eformss_${moment().format(
    //                 "MM_DD_YYYY[.zip]"
    //             )}`;
    //             aTag.click();
    //             URL.revokeObjectURL(result);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }

    useEffect(() => {
        fetchFormStatus();
        fetchData(1);
    }, []);

    useEffect(() => {
        fetchFormStatus();
    }, [i18n.language]);

    const onSubmit = () => {
        fetchData(1);
        setPage(0);
    };

    // 处理状态筛选
    function fetchSelectedFormStatus() {
        if (isObjectNotEmpty(formStatus)) {
            const allowed = ["0", "2", "4", "6", "8", "10", "20", "21", "22"];
            if (formId != null) {
                const formIdx = parseInt(formId.replace("Form", ""));

                if (Object.keys(formStatus).includes(formIdx.toString())) {
                    const filtered = Object.fromEntries(
                        Object.entries(formStatus[formIdx]).filter(
                            ([key, value]) => allowed.includes(key)
                        )
                    );
                    setSelectedFormStatus(filtered);
                } else {
                    const filtered = Object.fromEntries(
                        Object.entries(formStatus["common"]).filter(
                            ([key, value]) => allowed.includes(key)
                        )
                    );
                    setSelectedFormStatus(filtered);
                }
            } else {
                const filtered = Object.fromEntries(
                    Object.entries(formStatus["common"]).filter(
                        ([key, value]) => allowed.includes(key)
                    )
                );
                setSelectedFormStatus(filtered);
            }
        }
    }

    useEffect(() => {
        fetchSelectedFormStatus();
    }, [formId, formStatus]);

    const fetchReport = () => {
        if (isNotEmpty(submissionTime)) {
            const option = {
                url: `${Config.CONTENT_PATH}/workflow/getHistoryStatisticsByDate`,
                method: "POST",
                body: JSON.stringify({
                    submissionTime: submissionTime,
                }),
                header: {
                    Accept: "application/json",
                },
            };
            dispatch(send("GETHISTORYSTATISTICS", option))
                .then((res) => res.blob())
                .then((result) => {
                    let aTag = document.createElement("a");
                    aTag.href = URL.createObjectURL(result);
                    aTag.download = `signature_history_${moment(
                        submissionTime
                    ).format("MM_YYYY[.xlsx]")}`;
                    aTag.click();
                    URL.revokeObjectURL(result);
                    setReportOpen(false);
                    setSubmissionTime(null);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            return;
        }
    };
    return (
        <Container maxWidth="md">
            <AlertDialog
                formOpen={reportOpen}
                content={
                    <Box
                        style={{
                            width: "300px",
                            height: "200px",
                            wordBreak: "normal",
                            // textAlign: "center",
                        }}
                    >
                        <DialogContentText id="alert-dialog-description">
                            {t(`common.portal.selectDate`)}
                        </DialogContentText>
                        <CustomDatePicker
                            selected={submissionTime}
                            type="month"
                            control={control}
                            maxDate={new Date()}
                            // name={`submissionTime`}
                            onChange={(e) => {
                                setSubmissionTime(e);
                            }}
                        />
                    </Box>
                }
                confirmButton={{
                    action: () => {
                        fetchReport();
                    },
                    label: t("common.confirm"),
                }}
                closeButton={{
                    action: () => {
                        setReportOpen(false);
                        setSubmissionTime(null);
                    },
                    label: t("common.save.popup.cancel"),
                }}
            />
            <Header
                headerTitle={t("common.portal.HistoryEnquiry")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main className="main">
                    <Box style={{ marginLeft: "15px" }}>
                        <Box>
                            <Box display="flex">
                                <InputLabel
                                    htmlFor="formName"
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                >
                                    {t("common.portal.formName")}
                                    {t("common.colon")}
                                </InputLabel>
                                <Autocomplete
                                    id="formName"
                                    style={{ width: "80%" }}
                                    options={res.sort((a, b) => {
                                        let akey = a.formId.slice(4);
                                        let bkey = b.formId.slice(4);
                                        return -bkey.localeCompare(akey, {
                                            numeric: "true",
                                        });
                                    })}
                                    getOptionLabel={(option) => {
                                        return option.name;
                                    }}
                                    groupBy={(option) => option.formId}
                                    onChange={(e, newValue) => {
                                        if (newValue === null) {
                                            setFormId(null);
                                        } else {
                                            setFormId(newValue.formId);
                                        }
                                    }}
                                    blurOnSelect
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <div {...props} key={option.id}>
                                            {option.name}
                                        </div>
                                    )}
                                />
                            </Box>
                            <Box display="flex">
                                <InputLabel
                                    htmlFor="referenceNum"
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                >
                                    {t("common.portal.referenceNum")}
                                    {t("common.colon")}
                                </InputLabel>
                                <CustomTextField
                                    id="referenceNum"
                                    onChange={(e) =>
                                        setReferenceNum(e.target.value)
                                    }
                                />
                            </Box>
                            <Box
                                display="flex"
                                style={{
                                    paddingLeft:
                                        i18n.language === "en"
                                            ? "0rem"
                                            : "2rem",
                                }}
                            >
                                <InputLabel
                                    id="Category"
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                >
                                    {t("common.portal.status")}
                                    {t("common.colon")}
                                </InputLabel>
                                <Select
                                    label="Category"
                                    inputProps={{
                                        "aria-labelledby": "Category",
                                    }}
                                    defaultValue={""}
                                    displayEmpty
                                    style={{ width: "50%" }}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <MenuItem value="">
                                        {t("common.portal.all")}
                                    </MenuItem>
                                    {isObjectNotEmpty(selectedFormStatus) &&
                                        Object.entries(selectedFormStatus).map(
                                            ([key, value]) => (
                                                <MenuItem value={key} key={key}>
                                                    {key === "10"
                                                        ? value +
                                                          " " +
                                                          t("common.slash") +
                                                          " " +
                                                          t(
                                                              "common.statusEDBPendingReceive"
                                                          )
                                                        : value}
                                                </MenuItem>
                                            )
                                        )}
                                </Select>
                            </Box>

                            <Box mt={10} display="flex">
                                <Box
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                    component="span"
                                >
                                    {t("common.signingDate")}
                                    {t("common.colon")}
                                </Box>
                                <span
                                    style={{
                                        marginRight: "10px",
                                    }}
                                >
                                    {t("common.from")} {t("common.colon")}
                                </span>
                                <CustomDatePicker
                                    control={control}
                                    name={`submissionDateFrom`}
                                    onChange={(e) => {
                                        setSubmissionDateFrom(e);
                                    }}
                                />
                                <span
                                    style={{
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                    }}
                                >
                                    {t("common.to")} {t("common.colon")}
                                </span>

                                <CustomDatePicker
                                    control={control}
                                    name={`submissionDateTo`}
                                    onChange={(e) => {
                                        setSubmissionDateTo(e);
                                    }}
                                />
                            </Box>

                            <Box display="flex">
                                <Box
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                    component="span"
                                >
                                    {t("common.approval.signMethod")}
                                    {/* {t("common.colon")} */}
                                </Box>
                                <Controller
                                    control={control}
                                    name="status"
                                    render={({ field }) => (
                                        <FormControl
                                            id="Category"
                                            style={{ width: "50%" }}
                                        >
                                            <CustomSelect
                                                control={control}
                                                name={`signatureType`}
                                                defaultValue={"signatureType"}
                                                displayEmpty
                                                options={t(
                                                    `common.approval.signType`,
                                                    {
                                                        returnObjects: true,
                                                    }
                                                )}
                                                onChange={(e) =>
                                                    setSignatureType(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </FormControl>
                                    )}
                                />
                            </Box>
                            <Box display="flex">
                                <Box
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                    component="span"
                                >
                                    {t("common.approval.signingRole")}
                                    {t("common.colon")}
                                </Box>
                                <Controller
                                    control={control}
                                    name="roleType"
                                    render={({ field }) => (
                                        <FormControl
                                            id="Category"
                                            style={{ width: "50%" }}
                                        >
                                            <CustomSelect
                                                control={control}
                                                name={`signatureType`}
                                                defaultValue={"signatureType"}
                                                displayEmpty
                                                options={t(
                                                    `common.approval.signingRoleOption`,
                                                    {
                                                        returnObjects: true,
                                                    }
                                                )}
                                                onChange={(e) => {
                                                    console.log("e", e);
                                                    setRoleType(
                                                        parseInt(e.target.value)
                                                    );
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </Box>
                            <br />
                            <Button
                                variant="contained"
                                color="primary"
                                // style={{ marginLeft: "5rem", float: "right" }}
                                style={{
                                    marginLeft: "5rem",
                                }}
                                onClick={() => {
                                    setReportOpen(!reportOpen);
                                }}
                            >
                                {t("common.portal.report")}
                            </Button>
                            <Box
                                textAlign="end"
                                style={{
                                    marginLeft: "5rem",
                                    float: "right",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSubmit}
                                >
                                    {t("common.search")}
                                </Button>
                                <CustomTooltip
                                    title={t(
                                        "common.portal.formHistoryTooltip"
                                    )}
                                />
                            </Box>
                        </Box>
                        <br />
                        <TableContainer component={Paper}>
                            <Table
                                stickyHeader
                                size="small"
                                aria-label="a dense table"
                                component={"div"}
                            >
                                <TableHead component={"div"}>
                                    <TableRow component={"div"}>
                                        <TableCell />
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {i18n.language === "en"
                                                ? "Reference No."
                                                : t(
                                                      "common.portal.referenceNum"
                                                  )}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {i18n.language === "en"
                                                ? "Form"
                                                : "表格"}
                                        </TableCell>
                                        {/* <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.portal.status")}
                                        </TableCell> */}
                                    </TableRow>
                                </TableHead>

                                {!isObjectEmpty(searchResult) && (
                                    <TableBody component={"div"}>
                                        {searchResult.map((item, index) => (
                                            <HistoryTableRow
                                                key={index}
                                                rowData={item}
                                                formStatus={formStatus}
                                            />
                                        ))}
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={total}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={20}
                            rowsPerPageOptions={[20]}
                            labelDisplayedRows={({ from, to, count }) =>
                                i18n.language === "tc"
                                    ? `${count}個項目的 第${from}-${to}個`
                                    : i18n.language === "sc"
                                    ? `${count}个项目的 第${from}-${to}个`
                                    : `${from}-${to} of ${count}`
                            }
                        />
                    </Box>
                </main>
            </Box>
        </Container>
    );
}
export default HistoryEnquiry;
